import immer, { enablePatches } from 'immer';

enablePatches();

export default immer;
